import { render, staticRenderFns } from "./AssignTrackingTemplateMerchants.vue?vue&type=template&id=6bbd3df8&"
import script from "./AssignTrackingTemplateMerchants.vue?vue&type=script&lang=js&"
export * from "./AssignTrackingTemplateMerchants.vue?vue&type=script&lang=js&"
import style0 from "./AssignTrackingTemplateMerchants.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports